/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SegmentUsers } from '../../models/segment-users';

export interface GetUsersInSegment$Params {
  'Active-Tenant-Identifier': string;
  segmentId: string;
}

export function getUsersInSegment(http: HttpClient, rootUrl: string, params: GetUsersInSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<SegmentUsers>> {
  const rb = new RequestBuilder(rootUrl, getUsersInSegment.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('segmentId', params.segmentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SegmentUsers>;
    })
  );
}

getUsersInSegment.PATH = '/segments/{segmentId}/users';
